import Actions from "../actions";
import { produce } from "immer";

const initialState = {
    serviceProviderCustomers: {},
    selectedServiceProviderCustomerId:"",
    serviceProviderCustomersSelectList:[],
    selectedServiceProviderCustomerDetails:{},
    selectedServiceProviderCustomerIdForAppointmentViewDetails:""
};


const serviceProviderCustomers = produce((draft = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case Actions.GET_SERVICE_PROVIDER_CUSTOMERS_LIST: {
      draft.serviceProviderCustomers = payload?.serviceProviderCustomers;
      break;
    }

    case Actions.SELECTED_SERVICE_PROVIDER_CUSTOMER_ID: {
      draft.selectedServiceProviderCustomerId = payload?.selectedServiceProviderCustomerId;
      break;
    }

    case Actions.GET_SERVICE_PROVIDER_CUSTOMER_DETAILS: {
      draft.selectedServiceProviderCustomerDetails = payload?.selectedServiceProviderCustomerDetails;
      break;
    }

    case Actions.SELECTED_SERVICE_PROVIDER_CUSTOMER_ID_FOR_APPOINTMENT_VIEW_DETAILS: {
      draft.selectedServiceProviderCustomerIdForAppointmentViewDetails = payload?.selectedServiceProviderCustomerIdForAppointmentViewDetails;
      break;
    }

    default: {
      break;
    }
  }
}, initialState);

export default serviceProviderCustomers;
